<!--<div>-->
<!--  <h3>Teste</h3>-->
<!--  <login-form/>-->
<!--</div>-->
<div class="grid grid-cols-2 h-screen">
  <div class="h-full bgcolor-tg">
    <div class="flex h-full flex-col justify-around">
      <div class="mx-auto flex-initial">
        <img class="scale-75" alt="logo tg mob" src="images/logo/logo-white.png" height="109" width="385">
      </div>
      <div class="text-center">
        <div>
          <img class="2xl:scale-75 lg:scale-60 scale" alt="banner" src="images/home-img.png" height="437" width="604">
        </div>
        <div class="text-2xl text-white font-bold mb-3">Soluções em mobilidade urbana</div>
        <!--        <div class="text-sm text-white w-4/5 mx-auto">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do-->
        <!--          eiusmod tempor incididunt ut labore et dolore magna aliqua.-->
        <!--        </div>-->
      </div>
      <div class="footer mx-auto">
        <img src="images/logo/logo-prolins.png" height="56" width="110" alt="Logo Prolins">
      </div>
    </div>
  </div>
  <div class="h-full bgcolor-gray-sys">
    <div class="flex h-full flex-col justify-center">
      <mat-card class="card-login w-3/4 mx-auto">
        <img class="mx-auto scale-50" src="images/logo/logo-color.png" height="90" width="316" alt="Logo tg mob">
        @if (!formForgotPass) {
          <login-form class="w-3/4 mx-auto" (forgotPassword)="forgotPassword()"></login-form>
        } @else {
          <forgot-form class="w-3/4 mx-auto" (forgotPassword)="forgotPassword()"></forgot-form>
        }
      </mat-card>
    </div>
  </div>
</div>
<div style="
position: fixed;
bottom: 10px;
left: 10px;
color: white;
font-weight: bold;
font-size: small;
">
{{version}}
</div>
